import { Component, OnInit } from '@angular/core';
import { Faqs } from 'src/app/_models/faqs.model';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    standalone: false
})
export class FaqsComponent implements OnInit {

  public faqs: Faqs;

  constructor() { }

  ngOnInit(): void {
  }

}
